<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div class="decorative-icon">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/list.svg?alt=media&token=9188ff30-f684-431d-9e60-8b0af5dca73f"
          />
        </div>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <ion-row>
          <ion-col size="12">
            <p class="arrow-back-header mt-0 mb-1 ion-text-uppercase thin dark text-sm">
              <ion-icon
                mode="ios"
                name="arrow-dropleft-circle"
                class="mr-1 text-md cursor-pointer"
                color="primary"
                @click="gotoBack"
              ></ion-icon>Buscando inspiração?
            </p>
            <p class="mt-0 mb-0 white text-xxl ion-text-uppercase green">Receitas favoritas</p>
          </ion-col>
        </ion-row>
        <ion-row class="pt-3">
          <ion-col size="12">
            <div v-if="dishes.length > 0">
              <div class="dishes mt-2" v-for="dish in dishes" :key="dish.id">
                <div class="dish pt-0 pb-0 mb-2">
                  <ion-item lines="none" no-padding>
                    <ion-avatar slot="start" class="dish-avatar">
                      <ion-img v-if="dish.data.picture" :src="dish.data.picture"></ion-img>
                      <ion-img
                        v-else
                        src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/dish_grey.svg?alt=media&token=a4cfabaa-54e0-458f-858b-507f74630d1c"
                      ></ion-img>
                    </ion-avatar>
                    <ion-label>
                      <p class="mt-0 mb-0 dark text-sm bold ion-text-wrap">{{ dish.data.namePT }}</p>
                    </ion-label>
                    <div>
                      <ion-icon
                        mode="ios"
                        name="close-circle"
                        color="dark"
                        slot="end"
                        @click="dislikeDish(dish.id)"
                      ></ion-icon>
                      <ion-icon
                        mode="ios"
                        name="arrow-dropright-circle"
                        color="primary"
                        slot="end"
                        class="cursor-pointer ml-1"
                        @click="gotoDish(dish.id)"
                      ></ion-icon>
                    </div>
                  </ion-item>
                </div>
              </div>
            </div>
            <div v-else>
              <p
                class="mt-5 mb-5 pt-5 pb-5 darkgrey text-sm ion-text-center"
              >Nenhuma receita favorita foi encontrada</p>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-app>
</template>

<script>
// firebase
import db from "@/firebase/init";
import firebase from "firebase";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// store
import store from "../../utils/store.js";
// component
export default {
  name: "DishList",
  components: {
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: true,
      fullPage: true,
      user: store.state.user,
      profile: store.state.profile,
      dishes: []
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    startLoading() {
      const instance = this;
      instance.isLoading = true;
      setTimeout(() => {
        instance.loading = false;
      }, 3000);
    },
    gotoBack() {
      this.$router.go(-1);
    },
    gotoDish(dishId) {
      this.$router.push({
        name: "Favorite Meal",
        params: {
          dishId: dishId,
          proportion: 100
        }
      });
    },
    async dislikeDish(dishId) {
      const instance = this;
      instance.startLoading();
      // get user info
      const userId = instance.user.uid;
      const profileId = instance.profile.id;
      // update dish list
      const dishes = instance.dishes;
      for (let i = 0; i < dishes.length; i++) {
        if (dishes[i].id === dishId) {
          dishes.splice(i, 1);
        }
      }
      instance.dishes = dishes;
      // update user likes
      instance.like = {
        status: false,
        color: null,
        textClass: "mt-0 mb-0 text-sm ion-text-center white"
      };
      const likes = instance.profile.data.likes;
      for (let i = 0; i < likes.length; i++) {
        if (likes[i] === dishId) {
          likes.splice(i, 1);
        }
      }
      // update db
      if (dishId && userId && profileId && likes) {
        db.collection("dishes")
          .doc(dishId)
          .update({
            likes: firebase.firestore.FieldValue.arrayRemove(userId)
          });
        db.collection("users")
          .doc(profileId)
          .update({
            likes: likes
          });
        instance.profile.data.likes = likes;
        store.updateProfile(instance.profile);
      }
      instance.isLoading = false;
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    instance.user = store.state.user;
    instance.profile = store.state.profile;
    try {
      // get dishes
      const dishRef = db
        .collection("dishes")
        .where("likes", "array-contains", instance.user.uid);
      const dishSnap = await dishRef.get();
      dishSnap.forEach(doc => {
        const docObj = {
          id: doc.id,
          data: doc.data()
        };
        instance.dishes.push(docObj);
      });
      instance.isLoading = false;
    } catch (e) {
      console.log(e);
      instance.isLoading = false;
    }
  }
};
</script>

<style scoped>
ion-app {
  background: var(--bg-color-light) !important;
}
ion-content {
  --padding-bottom: 50px;
  --background: transparent !important;
}
ion-item {
  --padding-start: 10px;
  width: 100%;
}
.dish-avatar {
  height: 50px;
  width: 50px;
}
.dish {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 70px !important;
  width: 100%;
  border-radius: 15px !important;
  background: white;
  box-shadow: 0 12px 6px -3px rgba(0, 0, 0, 0.15);
  padding-right: 10px;
}
.dish-avatar {
  height: 50px;
  width: 50px;
}
.dish-icon {
  width: 1.75rem;
}
.dish ion-icon {
  font-size: 1.75rem;
}
.dish {
  position: relative;
  width: 100%;
  border-radius: 50px;
  background: white;
  box-shadow: 0 12px 6px -3px rgba(0, 0, 0, 0.15);
}
.arrow-back-header {
  display: flex;
  align-items: center;
}
</style>
